/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UpdateOrderItem } from './updateOrderItem';


export interface UpdateOrderCommand { 
    azureAdUpn?: string | null;
    deliveryPlace?: string | null;
    deliveryTime?: string | null;
    notes?: string | null;
    serviceTypeId?: number;
    shopId?: number;
    status?: number;
    compartmentOrderId?: number | null;
    shopServiceTimeSlotId?: number | null;
    orderItems?: Array<UpdateOrderItem> | null;
}

